import { Construction } from "lucide-react";
import PageHeader from "../components/PageHeader";

export default function ComingSoon({ title, phase }) {
  return (
    <div>
      <PageHeader title={title} subtitle="Modulo in arrivo" />
      <div className="bg-white rounded-2xl border border-slate-200 p-16 flex flex-col items-center text-center" data-testid="coming-soon">
        <div className="w-16 h-16 rounded-2xl bg-teal-50 flex items-center justify-center mb-5">
          <Construction className="w-8 h-8 text-teal-600" />
        </div>
        <h2 className="text-xl font-heading font-semibold text-slate-800">{title}</h2>
        <p className="text-slate-500 mt-2 max-w-md">Questo modulo fa parte della <span className="font-medium text-teal-700">{phase}</span> della roadmap. L'architettura dati è già predisposta — nessuna funzionalità simulata.</p>
        <span className="mt-5 text-xs font-mono uppercase tracking-widest text-slate-400 bg-slate-100 px-3 py-1.5 rounded-full">Coming soon</span>
      </div>
    </div>
  );
}
